module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAD1BMVEUAAAAjHyAjHyAjHyAjHyCMLXc/AAAABXRSTlMAUN//AByXhmwAAABHSURBVHgBY4CDUTAKGJWNMYCRiAsEMEBpYWMswBBNkTI2RUZoioyxAuorGlU0qmhU0aiiUUWEi2hyCntH/NUGPjAyFI0qAgCU2ueifIMEWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/25fe.png
// module id = 1341
// module chunks = 0